import { z } from "zod";
import { zString } from "./commonSchemaObjects";
export const protocolUploadSchema = z.object({
  protocol_name: zString.zRequired,
});
